import queryString from 'query-string';

import {
  formatUrl,
  formatJohnLewisUrl,
  formatLoyaltyExperiencesUrl,
  formatJohnLewisGiftingUrl,
  formatWalletPassesUrl,
} from './format-url';

export const buildUrl = (api = {}, path = '', query) =>
  api.query && query ? `${path}?${queryString.stringify(query)}` : path;

export const buildApiUrlOfType = (api, url = '') => {
  const {
    johnLewis = false,
    loyaltyExperiences = false,
    johnLewisGifting = false,
    walletPasses = false,
  } = api || {};
  if (loyaltyExperiences) {
    return formatLoyaltyExperiencesUrl(url);
  }
  if (walletPasses) {
    return formatWalletPassesUrl(url);
  }
  if (johnLewis) {
    return formatJohnLewisUrl(url);
  }
  if (johnLewisGifting) {
    return formatJohnLewisGiftingUrl(url);
  }
  return formatUrl(url);
};
